var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-header',{staticClass:"header",attrs:{"height":"auto"}},[_c('shop-header')],1),_c('el-main',[_c('transition',{attrs:{"name":"slide"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }